var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-full flex-col flex md:hidden",class:{
    'h-64': _vm.image,
    '-mb-24': _vm.image,
    'h-40': !_vm.image,
    '-mb-40': !_vm.image
  }},[_c('div',{staticClass:"h-full content-decor",class:{ shape: !_vm.image },style:(_vm.style)})])}
var staticRenderFns = []

export { render, staticRenderFns }